import React from "react";
// Styles
import * as S from '../styles';
// Helpers
import Imaging from 'src/helpers/imaging';

const Start = ({ data, settings }) => {
    return (
        <S.FeaturedImage className='mr-feat-image-section'>
            <Imaging data={data.feat_image} />
        </S.FeaturedImage>
    );
};

export default Start;